module.exports = __webpack_public_path__ + "img/imagePhone.4ff9d3b9.png";